import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';

import acl from './modules/acl';
import agent from './modules/agent';
import audit from './modules/audit';
import authentication from './reducers/application/Authentication';
import condo from './reducers/data/Condo';
import formGeneration from './modules/formGeneration';
import listing from './modules/listing';
import impersonation from './modules/impersonation';
import office from './modules/office';
import photo from './modules/photo';
import rowLock from './modules/rowLock';
import team from './reducers/data/Team';
import teamsManagement from './modules/teamsManagement';
import utility from './modules/utility';
import user from './modules/user';

export default combineReducers({
  acl,
  agent,
  audit,
  authentication,
  condo,
  formGeneration,
  impersonation,
  listing,
  office,
  photo,
  rowLock,
  team,
  teamsManagement,
  utility,
  user,
  router,
});
